import { render } from "./BlockViewer.vue?vue&type=template&id=5584ba3a&scoped=true"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=5584ba3a&scoped=true&lang=scss"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5584ba3a"]])

export default __exports__